// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__RhtUq","headlineContainer":"styles_headlineContainer__1hnVF","reportName":"styles_reportName__94frl"};